import * as React from 'react';
import { mergeClasses } from '@tcl-argon-utils/utils';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { useHeroButtonStyles } from './styles';

type ButtonElement = DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export interface HeroButtonProps extends ButtonElement {
  classes?: Record<string, string>;
  /** Tempus product logo. */
  logo: React.ReactElement;
  /** Whether the button is disabled. */
  disabled?: boolean;
  /** Label passed to button for screen reader use. */
  ariaLabel: string;
  /** If provided, used for minimum width of button. Must be more than 350px. */
  minWidth?: string;
}

export const HeroButton: React.FC<HeroButtonProps> = ({
  className = '',
  classes: classOverrides = {},
  logo,
  disabled = false,
  ariaLabel,
  minWidth = '350px',
  ...props
}) => {
  const classes = mergeClasses(
    useHeroButtonStyles({ disabled, minWidth }),
    {
      root: className,
    },
    classOverrides,
  );

  return (
    <button aria-label={ariaLabel} className={classes.root} aria-disabled={disabled} disabled={disabled} {...props}>
      <div className={classes.logoContainer}>{logo}</div>
    </button>
  );
};
